<template>
  <span>
    <span v-if="loading">
      <i class="fa fa-spinner fa-spin"></i>&nbsp; Please wait&hellip;
    </span>
    <span v-else-if="error">Error: {{ error }}</span>

    <span v-if="submerchant">
      <router-link
        :to="{ name: 'Submerchant Detail', params: { submerchantId: submerchant.id } }"
        :class="linkClasses"
      >{{ submerchant.name }}</router-link>
    </span>
  </span>
</template>
<script>
export default {
  name: "SubmerchantFragment",
  props: {
    submerchantId: {
      type: String,
      required: true
    },
    linkClasses: {
      type: String,
      required: false
    }
  },
  data() {
    return {
      submerchant: null,
      error: null,
      loading: false
    };
  },
  methods: {
    loadSubmerchant() {
      this.loading = true;
      this.axios
        .get(`/v1/submerchants/${this.submerchantId}?fields=name,id`)
        .then(response => {
          this.loading = false;
          if (response.status !== 200) {
            this.error = response.statusText;
            return;
          }

          this.submerchant = response.data;
        })
        .catch(error => {
          this.loading = false;
          // Request failed.
          this.error = error.response.statusText;
        });
    }
  },
  mounted() {
    this.loadSubmerchant();
  }
};
</script>

<style>
</style>
